import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Typography from "ds/components/Typography";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesBulkActionsResultItemProps = {
  roleBinding: ApiKeyViewRoleBinding;
  tab: BulkActionResultTabs;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const ApiKeyRolesBulkActionsResultItem = ({
  roleBinding,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: ApiKeyRolesBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={roleBinding.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        {roleBinding.role.isSystem ? (
          <Typography tag="p" variant="p-body3">
            {roleBinding.role.name}
          </Typography>
        ) : (
          <BulkActionsDrawerItemLink
            link={`/settings/role/${roleBinding.role.id}`}
            text={roleBinding.role.name}
            step={BulkActionsStep.Results}
            itemCategory={tab}
          />
        )}

        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(roleBinding.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(roleBinding.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default ApiKeyRolesBulkActionsResultItem;
